export const detectDeviceTypeByUserAgent = (userAgentString: string) => {
  const ua = userAgentString.toLowerCase();
  let isMobileUA = false;
  let isTabletUA = false;

  const mobileRegex =
    /(android|iphone|ipad|ipod|blackberry|windows phone|iemobile|opera mini|mobile)/i;

  const tabletRegex = /(ipad|android(?!.*mobi)|kindle|silk)/i; // 'android(?!.*mobi)' to only target Android tablet

  if (tabletRegex.test(ua)) {
    isTabletUA = true;
  } else if (mobileRegex.test(ua)) {
    isMobileUA = true;
  }

  // Special case for ipad often analysed as mobile for user agent
  if (ua.includes('ipad')) {
    isTabletUA = true;
    isMobileUA = false;
  }

  return { isMobileUA, isTabletUA };
};
